export const storeWithExpiry = (key: string, value: unknown, ttl: number) => {
  const today = new Date();
  const expiry = today.getTime() + ttl;
  const item = {
    value,
    expiry,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key: string) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};
